import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DoneIcon from '@material-ui/icons/Done';

import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ isMobile, theme }: { isMobile: boolean; theme: ICustomTheme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
    minWidth: isMobile ? 'auto' : theme.spacing(6),
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: isMobile ? 'row' : 'column',
  }),
);

interface NavButtonStyleProps extends ButtonProps {
  backgroundColor: string;
  isMobile: boolean;
}

// Filters custom style props so they never reach the DOM <button>
const FilteredButton: React.FC<NavButtonStyleProps> = ({
  backgroundColor: _backgroundColor,
  isMobile: _isMobile,
  ...rest
}) => React.createElement(Button, rest);

export const StyledNavButton = styled(FilteredButton)(
  ({
    theme,
    backgroundColor,
    isMobile,
  }: NavButtonStyleProps & { theme: ICustomTheme }) => ({
    width: isMobile ? theme.spacing(6) : theme.spacing(7),
    minWidth: isMobile ? theme.spacing(6) : theme.spacing(7),
    height: isMobile ? theme.spacing(6) : theme.spacing(7),
    padding: 0,
    borderRadius: '100%',
    color: theme.colors.white,
    backgroundColor: backgroundColor,
    boxShadow: theme.shadows[3],
  }),
);

export const StyledSecondaryNavButton = styled(FilteredButton)(
  ({
    theme,
    backgroundColor,
    isMobile,
  }: NavButtonStyleProps & { theme: ICustomTheme }) => ({
    width: isMobile ? theme.spacing(4) : theme.spacing(6),
    minWidth: isMobile ? theme.spacing(4) : theme.spacing(6),
    height: isMobile ? theme.spacing(4) : theme.spacing(6),
    padding: 0,
    marginTop: isMobile ? 0 : theme.spacing(6),
    borderRadius: '100%',
    color: theme.colors.white,
    backgroundColor: backgroundColor,
    boxShadow: theme.shadows[3],
  }),
);

export const StyledArrowUpIcon = styled(ArrowUpwardIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.caption.fontSize,
    maxWidth: theme.spacing(6),
    width: theme.spacing(6),
    '&.MuiSvgIcon-root': {
      height: 20,
    },
  }),
);

export const StyledArrowBackIcon = styled(ArrowBackIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.caption.fontSize,
    maxWidth: theme.spacing(6),
    width: theme.spacing(6),
    '&.MuiSvgIcon-root': {
      height: 30,
    },
  }),
);

export const StyledDoneIcon = styled(DoneIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.caption.fontSize,
    maxWidth: theme.spacing(6),
    width: theme.spacing(6),
    '&.MuiSvgIcon-root': {
      height: 30,
    },
  }),
);

export const StyledArrowForwardIcon = styled(ArrowForwardIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.caption.fontSize,
    maxWidth: theme.spacing(6),
    width: theme.spacing(6),
    '&.MuiSvgIcon-root': {
      height: 30,
    },
  }),
);
